import axios from "axios";
import { useCallback, useEffect, useState } from "react";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const http = axios.create({ baseURL: API, withCredentials: true });

let refreshing = null;
export const refreshSession = () => {
  refreshing ||= axios.post(`${API}/auth/refresh`, {}, { withCredentials: true }).finally(() => { refreshing = null; });
  return refreshing;
};

http.interceptors.response.use(null, async (err) => {
  const cfg = err.config;
  if (err.response?.status === 401 && cfg && !cfg._retry && !cfg.url.startsWith("/auth/") && !cfg.url.startsWith("/public/")) {
    cfg._retry = true;
    try { await refreshSession(); return http(cfg); } catch { window.dispatchEvent(new Event("jarvis:logout")); }
  }
  return Promise.reject(err);
});

export function formatError(e) {
  const d = e?.response?.data?.detail;
  if (!d) return e?.message || "Something went wrong";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return d.msg || String(d);
}

export const emitRefresh = () => window.dispatchEvent(new Event("jarvis:refresh"));

export function useResource(path) {
  const [data, setData] = useState(null);
  const load = useCallback(() => http.get(path).then((r) => setData(r.data)), [path]);
  useEffect(() => {
    load();
    window.addEventListener("jarvis:refresh", load);
    return () => window.removeEventListener("jarvis:refresh", load);
  }, [load]);
  return [data, load];
}

export const money = (n) => `$${Number(n || 0).toLocaleString()}`;
